module.exports = __webpack_public_path__ + "img/public relations.7bae661c.svg";